import { render } from "./GenericPage.vue?vue&type=template&id=4a58fb46"
import script from "./GenericPage.vue?vue&type=script&lang=js"
export * from "./GenericPage.vue?vue&type=script&lang=js"

import exportComponent from "D:\\perso\\miam\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__